import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Seguro } from 'src/app/models/seguro';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-seguro',
  templateUrl: './seguro.component.html',
  styleUrls: ['./seguro.component.css'],
  providers: [UserService]
})
export class SeguroComponent implements OnInit {

  public seguro = new Seguro();
  public parentescos;

  constructor(private _UserService: UserService) {  }

  ngOnInit(): void {
    this.getParentescos();
  }

  getParentescos(){
    this._UserService.httpGet('getParentescos').subscribe(
      (response: any) => {
        this.parentescos = response.details;
        console.log(this.parentescos)
      }, error =>{
        console.log(error)
      }
    )
  }

  guardar(form: NgForm){
    if(form.valid){
      console.log(form)
    }
  }

  

}
